// src/components/Customer/CustomerModal.jsx
import React, { useState, useEffect } from 'react';

const CustomerModal = ({ isOpen, onClose, onSave, isSaving, routes = [] }) => {
  const [formData, setFormData] = useState({
    name: '', shopName: '', lane: '', town: '', province: '',
    contactNumber: '', email: '', birthday: '', creditLimit: '',
    lat: '', lon: '', routeId: '', isActive: true
  });

  useEffect(() => {
    if (isOpen) {
      setFormData({
        name: '', shopName: '', lane: '', town: '', province: '',
        contactNumber: '', email: '', birthday: '', creditLimit: '',
        lat: '', lon: '', routeId: '', isActive: true
      });
    }
  }, [isOpen]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!formData.name.trim() || !formData.shopName.trim() || !formData.contactNumber.trim() || !formData.routeId) {
      alert('Please fill required fields: Name, Shop Name, Contact, Route');
      return;
    }

    const payload = {
      name: formData.name,
      shopName: formData.shopName,
      lane: formData.lane,
      town: formData.town,
      province: formData.province,
      contactNumber: formData.contactNumber,
      email: formData.email,
      birthday: formData.birthday,
      creditLimit: parseFloat(formData.creditLimit) || 0,
      lat: parseFloat(formData.lat) || 0,
      lon: parseFloat(formData.lon) || 0,
      routeId: formData.routeId,
      isActive: Boolean(formData.isActive),
    };

    onSave(payload);
  };

  if (!isOpen) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <header className="modal-header">
          <h3>Add New Customer</h3>
          <button className="close-modal-btn" onClick={onClose} disabled={isSaving}>×</button>
        </header>
        <div className="modal-body">
          <form id="customerForm" onSubmit={handleSubmit}>
            <div className="form-grid-modal">
              <label>Name *</label>
              <input name="name" className="custom-input" value={formData.name} onChange={handleChange} required disabled={isSaving} />
              
              <label>Shop Name *</label>
              <input name="shopName" className="custom-input" value={formData.shopName} onChange={handleChange} required disabled={isSaving} />
              
              <label>Lane</label>
              <input name="lane" className="custom-input" value={formData.lane} onChange={handleChange} disabled={isSaving} />
              
              <label>Town</label>
              <input name="town" className="custom-input" value={formData.town} onChange={handleChange} disabled={isSaving} />
              
              <label>Province</label>
              <input name="province" className="custom-input" value={formData.province} onChange={handleChange} disabled={isSaving} />
              
              <label>Contact Number *</label>
              <input name="contactNumber" className="custom-input" value={formData.contactNumber} onChange={handleChange} required placeholder="+9477XXXXXXX" disabled={isSaving} />
              
              <label>Email</label>
              <input name="email" type="email" className="custom-input" value={formData.email} onChange={handleChange} disabled={isSaving} />
              
              <label>Birthday</label>
              <input name="birthday" type="date" className="custom-input" value={formData.birthday} onChange={handleChange} disabled={isSaving} />
              
              <label>Credit Limit</label>
              <input name="creditLimit" type="number" className="custom-input" value={formData.creditLimit} onChange={handleChange} disabled={isSaving} />
              
              <label>Latitude</label>
              <input name="lat" type="number" step="any" className="custom-input" value={formData.lat} onChange={handleChange} disabled={isSaving} />
              
              <label>Longitude</label>
              <input name="lon" type="number" step="any" className="custom-input" value={formData.lon} onChange={handleChange} disabled={isSaving} />
              
              <label>Route *</label>
              <select name="routeId" className="custom-select" value={formData.routeId} onChange={handleChange} required disabled={isSaving}>
                <option value="">Select Route</option>
                {routes.map(route => (
                  <option key={route.id || route.routeId} value={route.id || route.routeId}>
                    {route.name}
                  </option>
                ))}
              </select>
              
              <label>Active</label>
              <input type="checkbox" name="isActive" checked={formData.isActive} onChange={handleChange} disabled={isSaving} />
            </div>
          </form>
        </div>
        <footer className="modal-footer">
          <button className="btn btn-cancel" onClick={onClose} disabled={isSaving}>Cancel</button>
          <button className="btn btn-save" type="submit" form="customerForm" disabled={isSaving}>
            {isSaving ? 'Saving...' : 'Save Customer'}
          </button>
        </footer>
      </div>
    </div>
  );
};

export default CustomerModal;
